import { Button } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

// sass
import "../../scss/common.scss";
import "../../scss/component.scss";


type Props = {
  headingText: string;
  appendClass?: string;
  toPrevious: () => void;
  close: () => void;
};

/**
 * モーダルのヘッダー部
 * 
 * @param param0 
 * @returns 
 */
const PartsModalHeaderWithBackButton: React.FC<Props> = (props) => {

  const { t } = useTranslation();

  const appendClass = props.appendClass ?? "";

  return (
    <div className={`modal-fixed-heading ${appendClass}`}>
      <p className="modal-fixed-heading-back">
        <button className="button-clear" onClick={props.toPrevious}><i className="icon-left-arrow-blue fz-20"></i></button>
      </p>
      <p className="modal-fixed-heading-text">{props.headingText}</p>
      <p className="modal-fixed-close">
        <Button onClick={props.close} className="modal-fixed-close-button">
          <i className="modal-fixed-close-button-icon"></i>{t("Common.閉じる")}
        </Button>
      </p>
    </div>
  );
};

export default PartsModalHeaderWithBackButton;
